(function() {
  // Title overflow check
  function checkTitleOverflow() {
    document.querySelectorAll('.product-card__title-wrapper').forEach(function(wrapper) {
      var textEl = wrapper.querySelector('.product-card__title-text');
      if (textEl && wrapper.offsetWidth < textEl.offsetWidth) {
        wrapper.classList.add('is-overflowing');
      } else {
        wrapper.classList.remove('is-overflowing');
      }
    });
  }
  
  // Price overflow check - marquee when prices don't fit
  function checkPriceOverflow() {
    document.querySelectorAll('.product-card__price-wrapper').forEach(function(wrapper) {
      var priceRow = wrapper.querySelector('.product-card__price-row:not(.product-card__price-row--duplicate)');
      if (priceRow && wrapper.offsetWidth < priceRow.scrollWidth) {
        wrapper.classList.add('is-overflowing');
      } else {
        wrapper.classList.remove('is-overflowing');
      }
    });
  }
  
  // Media carousel functionality (images + videos)
  var cardData = new Map();
  var IMAGE_DURATION = 3000; // 3 seconds per image
  
  function startCarousel(container) {
    var slider = container.querySelector('.product-card__image-slider');
    var progressContainer = container.querySelector('.product-card__image-progress');
    var pill = progressContainer ? progressContainer.querySelector('.product-card__progress-pill') : null;
    var mediaCount = parseInt(container.getAttribute('data-media-count'), 10);

    if (mediaCount <= 1) return;
    if (cardData.has(container)) return; // Already running

    // Lazily create deferred images if not yet loaded
    if (slider && slider.dataset.deferredMedia && !slider.dataset.loaded) {
      var urls = slider.dataset.deferredMedia.split('||');
      for (var u = 0; u < urls.length; u++) {
        if (!urls[u]) continue;
        var img = document.createElement('img');
        img.src = urls[u];
        img.alt = '';
        img.className = 'product-card__media product-card__image';
        img.setAttribute('width', '400');
        img.setAttribute('height', '533');
        img.loading = 'lazy';
        img.dataset.index = u + 1;
        img.dataset.type = 'image';
        slider.appendChild(img);
      }
      slider.dataset.loaded = 'true';
    }

    var mediaItems = container.querySelectorAll('.product-card__media');
    
    var currentIndex = 0;
    var timeoutId = null;
    var videoEndedHandler = null;
    
    function setPillDuration(durationMs) {
      if (pill) {
        pill.style.setProperty('--pill-duration', (durationMs / 1000) + 's');
      }
    }
    
    function restartPillAnimation() {
      if (pill) {
        pill.classList.remove('is-filling');
        void pill.offsetWidth; // Force reflow
        pill.classList.add('is-filling');
      }
    }
    
    function nextSlide() {
      var nextIndex = (currentIndex + 1) % mediaCount;
      showSlide(nextIndex);
    }
    
    function scheduleNextSlide() {
      var currentMedia = mediaItems[currentIndex];
      var isVideo = currentMedia && currentMedia.tagName.toLowerCase() === 'video';
      
      // Clean up previous handler
      if (videoEndedHandler) {
        mediaItems.forEach(function(m) {
          if (m.tagName.toLowerCase() === 'video') {
            m.removeEventListener('ended', videoEndedHandler);
          }
        });
      }
      
      if (isVideo) {
        // Create new handler for this video
        videoEndedHandler = function() {
          nextSlide();
        };
        currentMedia.addEventListener('ended', videoEndedHandler, { once: true });
        
        // Set pill duration to video duration
        if (currentMedia.duration && !isNaN(currentMedia.duration)) {
          setPillDuration(currentMedia.duration * 1000);
          restartPillAnimation();
        } else {
          // Wait for metadata
          currentMedia.addEventListener('loadedmetadata', function() {
            if (currentMedia.duration && !isNaN(currentMedia.duration)) {
              setPillDuration(currentMedia.duration * 1000);
              restartPillAnimation();
            }
          }, { once: true });
          // Start with default for now
          setPillDuration(IMAGE_DURATION);
          restartPillAnimation();
        }
      } else {
        // For images, use fixed duration
        setPillDuration(IMAGE_DURATION);
        restartPillAnimation();
        timeoutId = setTimeout(nextSlide, IMAGE_DURATION);
      }
    }
    
    function showSlide(newIndex) {
      var prevIndex = currentIndex;
      currentIndex = newIndex;
      
      // Clear any pending timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      
      // Smooth crossfade between media
      mediaItems.forEach(function(media, i) {
        var isVideo = media.tagName.toLowerCase() === 'video';
        
        if (i === prevIndex && i !== newIndex) {
          media.classList.add('is-leaving');
          media.classList.remove('is-active');
          if (isVideo) {
            media.pause();
            media.currentTime = 0;
          }
        } else if (i === newIndex) {
          media.classList.remove('is-leaving');
          media.classList.add('is-active');
          if (isVideo) {
            media.currentTime = 0;
            media.play().catch(function() {});
          }
        } else {
          media.classList.remove('is-active', 'is-leaving');
          if (isVideo) {
            media.pause();
            media.currentTime = 0;
          }
        }
      });
      
      // Remove leaving class after transition
      setTimeout(function() {
        mediaItems.forEach(function(media) {
          media.classList.remove('is-leaving');
        });
      }, 600);
      
      // Schedule next slide
      scheduleNextSlide();
    }
    
    // Initial setup - show first slide
    var firstMedia = mediaItems[0];
    var isFirstVideo = firstMedia && firstMedia.tagName.toLowerCase() === 'video';
    
    // Make sure first is active
    firstMedia.classList.add('is-active');
    
    // Start first video if needed
    if (isFirstVideo) {
      firstMedia.currentTime = 0;
      firstMedia.play().catch(function() {});
    }
    
    // Schedule next slide (this also starts the pill animation)
    scheduleNextSlide();
    
    cardData.set(container, {
      currentIndex: currentIndex,
      cleanup: function() {
        if (timeoutId) clearTimeout(timeoutId);
        if (videoEndedHandler) {
          mediaItems.forEach(function(media) {
            if (media.tagName.toLowerCase() === 'video') {
              media.removeEventListener('ended', videoEndedHandler);
            }
          });
        }
      }
    });
  }
  
  function stopCarousel(container) {
    var data = cardData.get(container);
    if (data) {
      if (data.cleanup) data.cleanup();
      cardData.delete(container);
    }
    
    // Reset to first media smoothly
    var mediaItems = container.querySelectorAll('.product-card__media');
    var pill = container.querySelector('.product-card__progress-pill');
    
    mediaItems.forEach(function(media, i) {
      var isVideo = media.tagName.toLowerCase() === 'video';
      media.classList.remove('is-leaving');
      media.classList.toggle('is-active', i === 0);
      
      if (isVideo) {
        media.pause();
        media.currentTime = 0;
      }
    });
    
    if (pill) {
      pill.classList.remove('is-filling');
      pill.style.removeProperty('--pill-duration');
    }
  }
  
  function initCarousels() {
    var containers = document.querySelectorAll('.product-card__image-container[data-media-count]');
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          startCarousel(entry.target);
        } else {
          stopCarousel(entry.target);
        }
      });
    }, {
      threshold: 0.5
    });
    
    containers.forEach(function(container) {
      var mediaCount = parseInt(container.getAttribute('data-media-count'), 10);
      if (mediaCount > 1) {
        observer.observe(container);
      }
    });
    
    // Handle single video cards (autoplay when in view, these keep loop attribute)
    var singleVideoCards = document.querySelectorAll('.product-card__image-container:not([data-media-count]) .product-card__video');
    if (singleVideoCards.length > 0) {
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function() {});
          } else {
            video.pause();
          }
        });
      }, {
        threshold: 0.5
      });
      
      singleVideoCards.forEach(function(video) {
        videoObserver.observe(video);
      });
    }
  }
  
  // Badge rotation functionality
  var badgeData = new Map();
  
  function startBadgeRotation(container) {
    var badges = container.querySelectorAll('.product-card__badge');
    var rotationSpeed = parseInt(container.getAttribute('data-rotation-speed'), 10) || 3;
    var rotationMs = rotationSpeed * 1000;
    
    if (badges.length <= 1) return;
    if (badgeData.has(container)) return; // Already running
    
    var currentIndex = 0;
    
    // Set initial active state
    badges[0].classList.add('is-active');
    
    function showBadge(newIndex) {
      var prevIndex = currentIndex;
      currentIndex = newIndex;
      
      badges.forEach(function(badge, i) {
        if (i === prevIndex && i !== newIndex) {
          badge.classList.add('is-leaving');
          badge.classList.remove('is-active');
        } else if (i === newIndex) {
          badge.classList.remove('is-leaving');
          badge.classList.add('is-active');
        } else {
          badge.classList.remove('is-active', 'is-leaving');
        }
      });
      
      // Remove leaving class after transition
      setTimeout(function() {
        badges.forEach(function(badge) {
          badge.classList.remove('is-leaving');
        });
      }, 300);
    }
    
    function nextBadge() {
      var nextIndex = (currentIndex + 1) % badges.length;
      showBadge(nextIndex);
    }
    
    var intervalId = setInterval(nextBadge, rotationMs);
    badgeData.set(container, { intervalId: intervalId });
  }
  
  function stopBadgeRotation(container) {
    var data = badgeData.get(container);
    if (data) {
      clearInterval(data.intervalId);
      badgeData.delete(container);
    }
    
    // Reset to first badge
    var badges = container.querySelectorAll('.product-card__badge');
    badges.forEach(function(badge, i) {
      badge.classList.remove('is-leaving');
      badge.classList.toggle('is-active', i === 0);
    });
  }
  
  function initBadgeRotation() {
    var rotatingContainers = document.querySelectorAll('.product-card__badges--rotating');
    
    if (rotatingContainers.length === 0) return;
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          startBadgeRotation(entry.target);
        } else {
          stopBadgeRotation(entry.target);
        }
      });
    }, {
      threshold: 0.3
    });
    
    rotatingContainers.forEach(function(container) {
      observer.observe(container);
    });
  }
  
  function formatMoney(cents, format) {
    if (window.formatMoney) {
      return window.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initSelectComponentsSafe() {
    if (!window.SelectComponent) return;
    document.querySelectorAll('[data-select]').forEach(function(el) {
      if (!el._selectComponent) {
        el._selectComponent = new window.SelectComponent(el);
      }
    });
  }

  function getSizedImageUrl(src, card) {
    if (!src) return src;
    if (!card) return src;
    var isCover = card.classList.contains('product-card--fit-cover');
    if (isCover) {
      return src.replace(/(\.[^.]+)$/, '_600x800_crop_center$1');
    }
    return src.replace(/(\.[^.]+)$/, '_600x$1');
  }

  function updatePriceRow(row, price, comparePrice, moneyFormat) {
    var priceEl = row.querySelector('.product-card__price');
    if (priceEl) {
      priceEl.textContent = formatMoney(price, moneyFormat);
    }

    var compareEl = row.querySelector('.product-card__compare-price');
    if (comparePrice && comparePrice > price) {
      if (!compareEl && priceEl) {
        compareEl = priceEl.cloneNode(true);
        compareEl.classList.remove('product-card__price');
        compareEl.classList.add('product-card__compare-price');
        priceEl.insertAdjacentElement('afterend', compareEl);
      }
      if (compareEl) {
        compareEl.textContent = formatMoney(comparePrice, moneyFormat);
      }
    } else if (compareEl) {
      compareEl.remove();
    }
  }

  function updatePriceDisplay(card, price, comparePrice) {
    var priceWrapper = card.querySelector('.product-card__price-wrapper');
    if (!priceWrapper) return;

    var moneyFormat = card.getAttribute('data-money-format') || window.themeMoneyFormat;
    var rows = priceWrapper.querySelectorAll('.product-card__price-row');
    rows.forEach(function(row) {
      updatePriceRow(row, price, comparePrice, moneyFormat);
    });

      checkPriceOverflow();
  }

  function updateProductImage(card, variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;
    var imageEl = card.querySelector('.product-card__image.is-active') || card.querySelector('.product-card__image');
    if (imageEl) {
      imageEl.src = getSizedImageUrl(variant.featured_image.src, card);
    }
  }

  function updateProductLinks(card, variantId) {
    var productLink = card.querySelector('.product-card__image-container');
    if (productLink && productLink.getAttribute('href')) {
      var baseLink = productLink.getAttribute('href').split('?')[0];
      productLink.setAttribute('href', baseLink + '?variant=' + variantId);
    }

    var addBtn = card.querySelector('.product-card__add-btn');
    if (addBtn && addBtn.tagName.toLowerCase() === 'a' && addBtn.getAttribute('href')) {
      var baseBtnLink = addBtn.getAttribute('href').split('?')[0];
      addBtn.setAttribute('href', baseBtnLink + '?variant=' + variantId);
    }
  }

  function initVariantSelectors() {
    document.querySelectorAll('.product-card[data-product-card] .product-card__variants').forEach(function(container) {
      if (container.hasAttribute('data-variants-initialized')) return;
      container.setAttribute('data-variants-initialized', 'true');

      var card = container.closest('.product-card');
      if (!card) return;

      var selectWrapper = container.querySelector('[data-select]');
      var nativeSelect = container.querySelector('.select__native');
      var variantsJson = card.querySelector('.product-card__variants-json');
      if (!nativeSelect || !variantsJson) return;

      var variants = [];
      try {
        variants = JSON.parse(variantsJson.textContent || '[]');
      } catch (e) {
        variants = [];
      }

      function updateAddButtonState(selectedVariant) {
        var addBtn = card.querySelector('[data-add-to-cart]');
        if (!addBtn || !selectedVariant) return;

        addBtn.dataset.variantId = selectedVariant.id;

        if (selectedVariant.available === true) {
          addBtn.disabled = false;
          addBtn.classList.remove('btn--disabled');
          var addText = addBtn.querySelector('.btn__text');
          if (addText) addText.textContent = 'Add to Cart';
          var addIcon = addBtn.querySelector('.btn__icon');
          if (addIcon) addIcon.style.display = '';
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('btn--disabled');
          var soldOutText = addBtn.querySelector('.btn__text');
          if (soldOutText) soldOutText.textContent = 'Out of Stock';
          var soldOutIcon = addBtn.querySelector('.btn__icon');
          if (soldOutIcon) soldOutIcon.style.display = 'none';
        }
      }

      function handleVariantChange(variantId) {
        if (!variantId) return;
        var selectedVariant = variants.find(function(variant) {
          return String(variant.id) === String(variantId);
        });
        if (!selectedVariant) return;

        updatePriceDisplay(card, selectedVariant.price, selectedVariant.compare_at_price);
        updateProductImage(card, selectedVariant);
        updateProductLinks(card, selectedVariant.id);
        updateAddButtonState(selectedVariant);
      }

      if (selectWrapper) {
        selectWrapper.addEventListener('select:change', function(e) {
          handleVariantChange(e.detail && e.detail.value);
        });
      }

      nativeSelect.addEventListener('change', function() {
        handleVariantChange(nativeSelect.value);
      });
    });
  }

  function initProductCards() {
    checkTitleOverflow();
    checkPriceOverflow();
    initCarousels();
    initBadgeRotation();
    initSelectComponentsSafe();
    initVariantSelectors();
    initAddToCartButtons();
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductCards();
    });
  } else {
    initProductCards();
  }

  document.addEventListener('product-card:updated', function() {
    initProductCards();
  });

  document.addEventListener('shopify:section:load', function() {
    initProductCards();
  });

  function initAddToCartButtons() {
    document.querySelectorAll('[data-product-card] [data-add-to-cart]').forEach(function(button) {
      if (button.hasAttribute('data-card-initialized')) return;
      button.setAttribute('data-card-initialized', 'true');

      button.addEventListener('click', handleAddToCart);
    });
  }

  async function handleAddToCart(e) {
    e.preventDefault();
    var button = e.currentTarget;
    var variantId = button.dataset.variantId;

    if (!variantId || button.classList.contains('btn--loading') || button.disabled) return;

    button.classList.add('btn--loading');
    button.disabled = true;

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      var addedItem = await response.json();
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();
      window.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: { item: addedItem, cart: cart }
      }));
      window.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cart }
      }));
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      button.classList.remove('btn--loading');
      button.disabled = false;
    }
  }
  
  // Run on resize
  window.addEventListener('resize', function() {
    checkTitleOverflow();
    checkPriceOverflow();
  });
})();
